import { useEffect, useState } from 'react';

export const useAsyncResource = (fetcher, deps = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetcher()
      .then((res) => {
        if (cancelled) return;
        setData(res.data);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, reloadKey]);

  const reload = () => setReloadKey((k) => k + 1);

  return { data, loading, error, reload };
};

// 402 ORGANIZATION_SUSPENDED payload (the organization was switched off
// commercially) or null. The interceptor leaves admin screens in place, so
// pages render the notice themselves.
export const getSuspension = (err) => {
  const resp = err?.response;
  if (resp?.status !== 402 || resp?.data?.code !== 'ORGANIZATION_SUSPENDED') return null;
  return resp.data;
};

export const unwrapResponse = (data) => {
  if (!data) return data;
  if (data.data !== undefined) return data.data;
  if (data.results !== undefined) return data.results;
  return data;
};

export const extractApiErrorMessage = (err) => {
  if (!err) return 'Unknown error.';
  const resp = err.response;
  if (resp?.status === 422 && resp?.data?.errors) {
    const first = Object.values(resp.data.errors)[0];
    if (Array.isArray(first) && first.length) return first[0];
  }
  return resp?.data?.message || err.message || 'Request failed.';
};
